import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isObject } from "./primitives";
var getUnique = function getUnique(array) {
  return array.filter(function (val, i, arr) {
    return arr.indexOf(val) === i;
  });
};
export var deepMerge = function deepMerge(target, source) {
  var copy = _objectSpread({}, target);
  var keys = getUnique([].concat(_toConsumableArray(Object.keys(target)), _toConsumableArray(Object.keys(source))));
  keys.forEach(function (k) {
    var key = k;
    if (isObject(source[key])) {
      if (!target[key]) {
        Object.assign(copy, _defineProperty({}, key, {}));
        Object.assign(target, _defineProperty({}, key, {}));
      }
      copy[key] = deepMerge(target[key], source[key]);
    } else if (typeof source[key] !== 'undefined') {
      Object.assign(copy, _defineProperty({}, key, source[key]));
    }
  });
  return copy;
};